<dialog #dialogElement>
  <div class="self-assessment-intro">
    <div class="self-assessment-intro__close-background" (click)="onClosed.emit(true)"></div>
    <div class="self-assessment-intro__content">
      <div class="self-assessment-intro__close" (click)="cancel()">
        <button role="button" aria-label="Selbsteinschätzung öffnen" autofocus>
          <brt-icon [icon]="'x-thin'"></brt-icon>
        </button>
      </div>
      <div class="self-assessment-intro__title">
        <brt-rough-headline [text]="'Berufe und ihre <em>Anforderungen</em>'"></brt-rough-headline>
      </div>
      <div class="self-assessment-intro__animation">
        <div class="self-assessment-intro__animation-container">
          <brt-lottie [lottieOptions]="{autoplay: true, loop: true, path: '/assets/lottie-animations/wizard-animation.json'}"></brt-lottie>
        </div>
      </div>


      <div class="self-assessment-intro__text">
        Egal ob mit Lehre, weiterführender Schule oder Studium – in jedem Beruf sind unterschiedliche Anforderungen von großer Bedeutung. Welche das sind und welche zu dir passen könnten, kannst du hier herausfinden.
      </div>

      <div class="self-assessment-intro__buttons-wrapper">
        <brt-button [color]="'red'" [title]="'Jetzt auswählen'" [size]="'large'" (click)="continue()"></brt-button>
        <button role="button" class="self-assessment-intro__cancel-button animline animline--black" (click)="cancel()">Nein danke</button>
      </div>
    </div>
  </div>


</dialog>
